<template>
    <div class="introMain" style="width: 100%;">
        <Section1 id="section1" />
        <Section2 id="section2" />
        <Section3 id="section3" />
        <Section4 id="section4" />
        <Section5 id="section5" />
        <Section6 id="Section6" />
        <Footer id="footer" />
    </div>
</template>
<script>
import Section1 from './content/Section1.vue'
import Section2 from './content/Section2.vue'
import Section3 from './content/Section3.vue'
import Section4 from './content/Section4.vue'
import Section5 from './content/Section5.vue'
import Section6 from './content/Section6.vue'
import Footer from '../content/Footer.vue'
export default {
    components: {
        Section1,
        Section2,
        Section3,
        Section4,
        Section5,
        Section6,
        Footer
    },
    data() {
        return {
            lastScrollTime: 0,
            activeSection: 1,
            isScroll: false,
            isMoving: false,
            timeout: null
        }
    },
    computed: {
        scrollY() {
            return this.$store.state.scrollY
        }
    },
    methods: {
    },
}
</script>
<style>
    body {
        /* font-family: 'Pretendard' !important; */
    }
    .introMain section p {
        line-height: 1.5;
    }
    .introMain section .con_wrap {
        width: 100%;
        max-width: 1180px;
        margin: 0 auto;
    }
    .introMain .arrow_bottom {
        -webkit-animation: flickerAnimation 2s infinite;
        -moz-animation: flickerAnimation 2s infinite;
        -o-animation: flickerAnimation 2s infinite;
        animation: flickerAnimation 2s infinite;
        margin-top: 67px;
        color: white;
    }
    @keyframes flickerAnimation {
        0% {
            margin-bottom: 10px;
            opacity: 0;
        }
        50% {
            margin-bottom: 0px;
            opacity: 1;
        }

        100% {
            margin-bottom: 10px;
            opacity: 0;
        }
    }
    @-o-keyframes flickerAnimation {
        0% {
            margin-bottom: 10px;
            opacity: 0;
        }
        50% {
            margin-bottom: 0px;
            opacity: 1;
        }

        100% {
            margin-bottom: 10px;
            opacity: 0;
        }
    }
    @-moz-keyframes flickerAnimation {
        0% {
            margin-bottom: 10px;
            opacity: 0;
        }
        50% {
            margin-bottom: 0px;
            opacity: 1;
        }

        100% {
            margin-bottom: 10px;
            opacity: 0;
        }
    }
    @-webkit-keyframes flickerAnimation {
        0% {
            margin-bottom: 10px;
            opacity: 0;
        }
        50% {
            margin-bottom: 0px;
            opacity: 1;
        }

        100% {
            margin-bottom: 10px;
            opacity: 0;
        }
    }
</style>